export const LIST_VIEW = 'list-view';
export const STRIP_VIEW = 'strip-view';
